import React, { useEffect, useRef, useState } from 'react'
import {Card, Col, Form, message, Row, Select} from "antd";
import { useSwitch } from '../pages/SwitchContext';
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useLocation } from 'react-router-dom';
import { useNavigate, useParams } from "react-router-dom";
import { apiGet, apiPut, parseJsonResponse } from "../api/apiClient";
import { getInitialValuesFormular, updateDataContent } from "../utils/formUtils";
import { SaveIcon } from "../components/ui/SaveIcon";
import TextArea from 'antd/lib/input/TextArea';
const { Option } = Select;

const TextbausteineEdit = () => {
    const { isSwitchOn } = useSwitch();
    const location = useLocation();
    const { state } = location;

    const [saveIcon, setSaveIcon] = useState(false);
    const [saveIcon1, setSaveIcon1] = useState(false);
    const { id } = useParams();
    const [formFormular] = Form.useForm();
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dataContentRef = useRef(null);
    const [enumerationValuesContent, setEnumerationValuesContent] = useState(null);

    const handleSelectChange = (value) => {
        setSelectedOption(value);
    }

    const fetchData = async () => {
        try {
            const [tbRes, enumRes] = await Promise.all([
                apiGet(`/textbausteines/${id}?populate=deep`),
                apiGet('/textbausteine/enumvalues'),
            ]);
            const dataContainer = await parseJsonResponse(tbRes);
            dataContentRef.current = dataContainer.data.attributes;
            setEnumerationValuesContent(await parseJsonResponse(enumRes));
        } catch (error) {
            message.error("Error while fetching enumerationValues!");
            console.error(error);
        }
    };


    useEffect(() => {
        fetchData().then(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            {!isLoading && dataContentRef.current && enumerationValuesContent && (
            <div style={{ padding: '20px' }} className={`lg:w-[84%] w-[90%] ml-auto mr-[2%] rounded-[30px]  ${isSwitchOn ? 'bg-black' : 'bg-white'}`}>
                {saveIcon1 && <SaveIcon saveIcon={saveIcon} />}
                <h2 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'} mb-[15px]`}>Textbausteine ​​bearbeiten</h2>
                <Link
                    to="/textbausteine"
                    type="primary"
                    icon={<ArrowLeftOutlined />} className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  mt-[10px] p-[10px] rounded-full LinkHover`}>
                    Zurück zur Übersicht
                </Link>
                <Card className={`mt-[30px] border-none ${isSwitchOn ? 'bg-black' : 'bg-white'}`}>
                    <Form
                        form={formFormular}
                        layout="vertical"
                        initialValues={getInitialValuesFormular(dataContentRef.current)}
                        onBlur={(e) => {
                            const updateValue = e.target.id === "Kategorie" ? selectedOption : e.target.value;
                            updateDataContent(e.target.id, updateValue, dataContentRef.current);
                            setSaveIcon(true);
                            setSaveIcon1(true);
                            apiPut(`/textbausteines/${id}/`, { data: dataContentRef.current })
                                .then(response => {
                                    if (!response.ok) throw new Error('Failed to update data.');
                                    setTimeout(() => setSaveIcon(false), 300);
                                    setTimeout(() => setSaveIcon1(false), 3000);
                                })
                                .catch(error => console.error('Error:', error));
                        }}
                    >
                        <Row className="flex-col items-center">
                            <Col className="w-[300px] sm:w-[400px]">
                                <Form.Item
                                    label="Textbaustein"
                                    name="Textbaustein_Satz"
                                    className={` ${isSwitchOn ? 'formprofile1' : 'formprofile'}`}
                                >
                                    <TextArea placeholder="Textbaustein" className="inputProfile" />
                                </Form.Item>
                            </Col>
                            <Col className="w-[300px] sm:w-[400px]">
                                <Form.Item
                                    label="Kategorie"
                                    name="Kategorie"
                                    className={` ${isSwitchOn ? 'formprofile1' : 'formprofile'}`}
                                >
                                    <Select onChange={handleSelectChange}>
                                        {enumerationValuesContent.Kategorie.map((option, index) => (
                                            <Option key={index} value={option}>
                                                {option}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                </Card>
            </div >
            )}
        </>
    )
}

export default TextbausteineEdit;
